export default {
	"general": "Bridge",
	"projectOverview": "Project Overview",
	"projectInfo": "Project Information",
	"monitorInfo": "Monitoring Information",
	"projectList": "Collection System",
	"device": "Device Management",
	"debugAndInstall": "Debug and Installation",
	"collectionConfig": "Collection Settings",
	"dataRetrieval": "Collection Tracking",
	"tempCorrection": "Data Constraints",
	"detectionList": "Device Status Monitoring",
	"point": "Measurement Point Information",
	"pointList": "Measurement Point Management",
	"relationPoint": "Associated Measurement Point Configuration",
	"warningsSet": "Warning Settings",
	"formulaConfig": "Formula Configuration",
	"zeroValueConfig": "Zero Value Settings",
	"configfFormula": "Inverse Formula Configuration",
	"warningInfo": "Warning Messages",
	"intelligentDevice": "Intelligent Tension Force",
	"remediateModel": "Model Correction",
	"dataAndReport": "Statistical Analysis",
	"projectStatistics": "Project Statistics",
	"spotStatistics": "Measurement Point Statistics",
	"deviceStatistics": "Device Statistics",
	"SIMManager": "SIM Ledger",
	"statusStatistics": "Device Status Statistics",
	"bridgeAnalysis": "Directional Analysis",
	"onLineAnalysis": "Traffic Flow Analysis",
	"onLineAssessment": "Real-Time Assessment",
	"onLineTraffic": "Traffic Analysis",
	"windCharacter": "Wind Speed and Direction Analysis",
	"vortexVibration": "Vortex Vibration Analysis",
	"analysis": "Data Analysis",
	"report": "Results Report",
	"waveAnalysis": "Data Fluctuation Analysis",
	"correlationAnalysis": "Correlation Analysis",
	"timeSharingAnalysis": "Time-sharing Analysis",
	"modality": "Modal Analysis",
	"backstag": "Management Backend",
	"basicConfig": "Basic Configuration",
	"productsList": "Product List",
	"baseFormulaConfig": "Channel Formula",
	"systemFactorList": "Monitoring Factors Management",
	"sensorModel": "Sensor Category Code Formula Configuration",
	"authority": "Permission Management",
	"userList": "User Management",
	"roleList": "Role Management",
	"menuList": "Menu Management",
	"systemConfig": "System Settings",
	"dataDictionaryList": "Data Dictionary",
	"cooperator": "Cooperating Units",
	"interfaceCustomization": "Interface Customization",
	"commandConfig": "Communication Command Configuration",
	"editChart": "Full Bridge Point Maintenance",
	"customerManage": "Customer Management",
	"projectManage": "Project Management",
	"contractManage": "Contract Management",
	"invoiceManage": "Invoice Management",
	"feedBackList": "User Feedback",
	"deviceSearch": "Device Search",
	"inspectionRecord": "Inspection Records",
	"systemLog": "Log Management",
	"abnormalLog": "Abnormal Logs",
	"collectLog": "Collection Logs",
	"handleLog": "Operation Logs",
	"dataPush": "Data Push",
	"pushConfig": "Push Configuration",
	"missionControl": "Mission Monitoring",
	"dtuCollectionMonitoring": "DTU Collection Monitoring",
	"speedDTUMng": "Accelerated DTU Collection Monitoring",
	"assessment": "Data Management",
	"importData": "Data Import",
	"download": "Download Center",
	"batchDelete": "Batch Deletion",
	"dataProcessing": "Data Processing Configuration",
	"outcomeDataProcessing": "Result Data Processing Configuration",
	"userClientList": "User Management",
	"roleClientList": "Role Management",
	"reportManage": "Report Management",
	"correction": "Correction System",
	"setting": "Information Configuration",
	"dataAnalysis": "Data Analysis",
	"jiupianReport": "Data Report",
	"healthAssess": "Health Assessment",
	"contingencies": "Emergency Events"
}
